<div class="input-group mb-3">
  <input
    [(ngModel)]="searchString"
    type="text"
    class="form-control form-control-lg"
    [class.dimmed-border]="!searchString.trim().length"
    (keyup.enter)="search()"
    placeholder="Enter a container or booking number">

  <button
    class="btn btn-lg btn-primary px-md-4 pt-2"
    (click)="search()"
    type="button"
    [disabled]="!searchString.trim().length">

    <svg class="me-sm-2" fill="currentColor" width="20" height="20" style="position: relative; top: -2px;">
      <use href="/assets/icons.svg#icon-search"></use>
    </svg>

    <span class="d-none d-sm-inline">Search&nbsp;</span>
  </button>
</div>
